import $ from 'jquery';
import { currentUser } from 'js/utils/user';

export function set_gmtoffset(url: string) {
  const params = {
    minutes: new Date().getTimezoneOffset(),
  };
  if (currentUser) {
    $.post(url, params);
  } else {
    $.get(url, params);
  }
}

export default set_gmtoffset;
